import { getMcAppFromBaseProps } from "../lib/baseProps";
import {
  CommonParameters,
  IBaseProps,
  IMcAppType,
  NavFlow,
  Tab,
} from "../mcApp.types";

const baseProps = {
  navFlow: NavFlow.FOCUS,
  parent: Tab.MORE,
  parameters: {
    required: ["caid"],
    properties: { caid: CommonParameters.caid },
  },
};

const createPaymentPlanMcApp = ({
  name,
  ...props
}: IBaseProps): IMcAppType[] => {
  name = `paymentPlan${name}`;
  return [
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_SAP`,
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_MAGICLINK`,
      magiclinkPath: "/task/payment-plans",
      intent: name,
    }),
  ];
};

const paymentPlanApps: IBaseProps[] = [
  {
    name: "Cancel",
    path: "/my-account/payment-plans",
    subPath: "cancel",
    description: "Cancel payment plan",
    title: "Cancel payment plan",
    ...baseProps,
  },
  {
    name: "Edit",
    path: "/my-account/payment-plans",
    subPath: "edit/select-options",
    description: "Edit payment plan",
    title: "Edit payment plan",
    ...baseProps,
  },
  {
    name: "SetUp",
    path: "/my-account/payment-plans",
    subPath: "setup/select-options",
    description: "Setup payment plan",
    title: "Payment plans",
    ...baseProps,
  },
  {
    name: "ViewSchedule",
    path: "/my-account/payment-plans",
    subPath: "view-schedule",
    description: "View payment schedule",
    title: "Your payment schedule",
    ...baseProps,
  },
];

export const paymentPlan: IMcAppType[] = paymentPlanApps.flatMap((app) =>
  createPaymentPlanMcApp(app)
);
